import React from "react";
import { SHr, SImage, SNavigation, SPage, SPopup, SText, STheme, SThread, SView } from "servisofts-component2";
import { check, request, PERMISSIONS, RESULTS, checkNotifications, openSettings } from 'react-native-permissions';

// import BottomNavigator from "../../Components/BottomNavigator";
import SSocket from "servisofts-socket";
import Container from "../../Components/Container";
import PButtom from "../../Components/PButtom";
import { SBackgroundLocation } from "servisofts-background-location";

export default class notificacion extends React.Component {
  // static FOOTER = <BottomNavigator url={"/sucursal"} />

  state = {
    sucursales: [],
    loading: false,
  };
  componentDidMount() {
    this.loadData();
    this.hiloRun = true;
    this.hilo();
  }
  componentWillUnmount() {
    this.hiloRun = false;
  }


  hilo = async () => {
    if (!this.hiloRun) return false;
    new SThread(1000, "hilo_permiso_backgroundlocation", true).start(() => {
      if (!this.hiloRun) return false;
      this.loadData();
      this.hilo();
    })
  }

  async loadData() {
    SBackgroundLocation.isNotificationPermissionGranted().then(({ granted }) => {
      if (granted) {
        console.log("Notification granted:", granted);
        SNavigation.replace("/permiso/bateria");
        return;
      }
    }).catch(e => {
      console.error(e);
    })
  }

  detalleConfirmacion(data) {
    // var INSTACE = this;
    // const usuario = MDL.usuario.session;
    // if (!usuario) return <SLoad />

    return <SView
      style={{
        width: "100%",
        maxWidth: 365,
        minHeight: 210,
        borderRadius: 30,
        padding: 15
      }}
      center
      backgroundColor={STheme.color.background}
    >
      <SHr />
      <SHr />
      <SView col={"xs-10"} center>
        <SText color={STheme.color.text} style={{ fontSize: 17 }} center >¿Cómo activarlo si está deshabilitado?</SText>
      </SView>
      <SView col={"xs-12"} style={{ marginTop: 10, height: 1, backgroundColor: STheme.color.gray }} />
      <SHr height={20} />
      <SView col={"xs-12"} flex>
        <SText>Ve a</SText>
        <SText bold>- Ajustes de celular</SText>
        <SText bold style={{ paddingLeft: 10 }} >- Aplicaciones</SText>
        <SText bold style={{ paddingLeft: 15 }}>- ROR GO</SText>
        <SText bold style={{ paddingLeft: 20 }}>- Notificaciones</SText>
        <SText>y activar</SText>
        <SText bold style={{ paddingLeft: 25 }}>Permitir notificaciones</SText>
      </SView>
      <SHr height={20} />
      <SView flex />
      <SView col={"xs-12"} style={{ alignItems: "flex-end" }}>
        <PButtom small onPress={() => {
          openSettings("application");
        }} >Ir a ajustes</PButtom>

      </SView>
      <SHr height={10} />
    </SView>
  }

  render() {
    return <SPage
      disableScroll
      title={"Permisos"}
    >
      <Container flex height padding={15}>
        <SView center col={"xs-12"} height card padding={15}>
          <SText backgroundColor={STheme.color.primary} col={"xs-12"} center padding={10} style={{ borderRadius: 4 }} fontSize={18} bold>Permiso de notificaciones</SText>
          <SHr height={10} />
          <SView width={250} height={250} center>
            <SImage src={require('../../Assets/img/notificacion.png')} style={{ resizeMode: 'contain' }} />
          </SView>
          <SText fontSize={15} >¿Por qué necesitamos este permiso?</SText>
          <SHr height={10} />
          <SText fontSize={12} center >Las notificaciones te permiten recibir avisos importantes, recordatorios y actualizaciones en tiempo real para que no te pierdas nada relevante.</SText>
          <SHr height={15} />
          <SView col={"xs-12"} flex style={{ alignItems: "flex-end" }}>
            <SText underLine onPress={() => {
              SPopup.open({ key: "detallePopup", content: this.detalleConfirmacion() });
            }}>¿Cómo activarlo?</SText>
          </SView>
          <SHr height={20} />
          <PButtom primary onPress={() => {
            this.loadData();
            SBackgroundLocation.requestNotificationPermission().then(e => {
              this.loadData();
            }).catch(e => {
              console.error(e);
            })
            // SNavigation.navigate("/permiso/bateria");
          }}>PERMITIR</PButtom>
        </SView>
      </Container>
    </SPage>
  }
}